import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  icons: { iconfont: 'mdi' },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#643D1D',
        secondary: '#424242',
        accent: '#643D1D',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
})
